// extracted by mini-css-extract-plugin
export default {"steps":"Steps_steps__eNt9D","stepGroup":"Steps_stepGroup__oGGSL","stepText":"Steps_stepText__ZEE-C","step":"Steps_step__2qXND","selected":"Steps_selected__NVFJg"};